import { __extends } from "tslib";
import { ImageSampler } from '@awayjs/stage';
import { LightBase } from './LightBase';
var LightProbe = /** @class */ (function (_super) {
    __extends(LightProbe, _super);
    function LightProbe(diffuseMap, specularMap) {
        if (specularMap === void 0) { specularMap = null; }
        var _this = _super.call(this) || this;
        _this.diffuseSampler = new ImageSampler();
        _this.specularSampler = new ImageSampler();
        _this.diffuseMap = diffuseMap;
        _this.specularMap = specularMap;
        return _this;
    }
    Object.defineProperty(LightProbe.prototype, "assetType", {
        get: function () {
            return LightProbe.assetType;
        },
        enumerable: false,
        configurable: true
    });
    LightProbe.assetType = '[light LightProbe]';
    return LightProbe;
}(LightBase));
export { LightProbe };
